export default {
  metaInfo: {
    title: '联系我们-京奇数据智慧营销',
    meta: [{
      name: "description",
      content: "四川京奇数据科技有限公司自2003年成立以来，深耕大数据科技领域，专注于为房地产、互联网和电子产品制造供应链等行业提供创新解决方案。凭借强大的大数据沉淀和行业洞察力，公司已发展成为集房产智悦拎包、京小电节能、京东服务+推广等核心业务于一体的综合性大数据科技公司。我们致力于通过技术创新和优质服务，为客户创造价值，推动行业的可持续发展。"
    }, {
      name: "keywords",
      content: "四川京奇数据科技、关于我们、公司简介、大数据科技公司、房地产大数据、供应链整合、房产智悦拎包、京小电节能、京东服务+推广、企业发展历程、创新型企业、可持续发展"
    }],
    link: [{
      rel: '',
      href: ''
    }]
  }
};